<template>
  <v-container fluid>
    <v-card>
      <v-card-title>
        Cadastro de Turmas com Abas
        <v-spacer />
        <!-- <v-btn color="primary" @click="adicionarLinha">Adicionar Turma</v-btn> -->
      </v-card-title>

      <v-card-text>
        <div v-for="(turma, index) in turmas" :key="index" class="mb-8 mt-4">
          Turma {{ index + 1 }}
          <v-card class="pa-4">
            <v-tabs v-model="abas[index]" background-color="primary" dark grow>
              <v-tab>Identificação</v-tab>
              <v-tab>Horários</v-tab>
              <v-tab>Tipos</v-tab>
              <v-tab>Atividades</v-tab>
              <v-tab>Outros</v-tab>
              <v-tab>Organização</v-tab>
              <v-tab>Áreas</v-tab>
            </v-tabs>

            <v-tabs-items v-model="abas[index]">
              <v-tab-item>
                <v-row class="mt-4">
                  <v-col cols="3"
                    ><v-text-field
                      v-model="turma.codigo_turma_entidade"
                      label="Cód. Entidade/Escola"
                      dense
                      outlined
                  /></v-col>
                  <v-col cols="6"
                    ><v-text-field v-model="turma.descricao" label="Nome da Turma" dense outlined
                  /></v-col>
                  <v-col cols="3">
                    <v-select
                      :items="[
                        '1 - Presencial',
                        '2 - Semipresencial',
                        '3 - Educação a distância - EAD',
                      ]"
                      v-model="turma['tipo_mediacao_didatico_pedagogica']"
                      :label="'Tipo de mediação didático-pedagógica'"
                      dense
                      :rules="[requiredRule]"
                      outlined
                      required
                    />
                  </v-col>
                </v-row>
              </v-tab-item>

              <v-tab-item>
                <v-row class="mt-4">
                  <v-col v-for="dia in diasSemana" :key="dia" cols="3">
                    <v-card class="">
                      <v-card-title>{{ dia }}</v-card-title>
                      <v-card-text>
                        <v-text-field
                          v-model="turma[`horario_${dia}_inicio`]"
                          :label="`Horário - Início`"
                          dense
                          type="time"
                          outlined
                        />
                        <v-text-field
                          v-model="turma[`horario_${dia}_fim`]"
                          :label="`Horário - Fim`"
                          dense
                          type="time"
                          outlined
                        />
                      </v-card-text>
                    </v-card>
                  </v-col>
                </v-row>
              </v-tab-item>

              <v-tab-item>
                <v-row class="mt-4">
                  <v-col cols="12">
                    <h4>Tipo de Turma</h4>
                  </v-col>

                  <v-col>
                    <v-checkbox
                      v-model="turma.tipo_turma_curricular"
                      :label="'Turma Curricular'"
                      dense
                      outlined
                    />
                  </v-col>
                  <v-col>
                    <v-checkbox
                      v-model="turma.tipo_turma_aee"
                      :label="'Turma AEE'"
                      dense
                      outlined
                    />
                  </v-col>
                  <v-col>
                    <v-checkbox
                      v-model="turma.tipo_turma_atividade_complementar"
                      :label="'Atividade complementar'"
                      dense
                      outlined
                    />
                  </v-col>
                </v-row>
              </v-tab-item>

              <v-tab-item>
                <v-row class="mt-4" v-if="turma.tipo_turma_atividade_complementar">
                  <v-col v-for="i in 6" :key="'atv' + i" cols="3">
                    <label for="">{{ "Atividade Compl. " + i }}</label>
                    <e-autocomplete
                      :items="$constants.tipoAtividadeComplementarList"
                      :return-object="false"
                      :item-value="(value) => value.codigo"
                      :item-text="(val) => `${val.codigo} - ${val.nome}`"
                      v-model="turma[`atividade_complementar_${i}`]"
                      :label="`Atividade ${i}`"
                      dense
                      solo
                    />
                  </v-col>
                </v-row>
              </v-tab-item>

              <v-tab-item>
                <v-row class="mt-4">
                  <v-col cols="4">
                    <label for="">Etapa agregada</label>
                    <e-autocomplete
                      :items="etapasAgregadas"
                      :return-object="false"
                      :item-value="(value) => String(value.codigo)"
                      :item-text="(val) => `${val.codigo} - ${val.nome}`"
                      v-model="turma.etapa_agregada"
                      label="Etapa agregada"
                      dense
                      solo
                    />
                  </v-col>
                  <v-col cols="4"
                    ><v-checkbox
                      v-model="turma.turma_educacao_especial"
                      label="Turma de Educação Especial(Classe especial)"
                      dense
                      outlined
                  /></v-col>
                  <v-col cols="4">
                    <e-autocomplete
                      :items="$constants.etapasList"
                      :return-object="false"
                      :item-value="(value) => String(value.codigoEtapaEnsino)"
                      :item-text="(val) => `${val.codigoEtapaEnsino} - ${val.nomeEtapaEnsino}`"
                      v-model="turma.etapa"
                      label="Etapa"
                      dense
                      solo
                    />
                  </v-col>
                  <v-col
                    cols="4"
                    v-if="turma.etapa === 39 || turma.etapa === 40 || turma.etapa === 64"
                  >
                    <label>Cód. Curso</label>
                    <e-autocomplete
                      :items="$constants.cursosEducacaoProfissionalList"
                      :return-object="false"
                      :item-value="(value) => value.codigo"
                      :item-text="(val) => `${val.codigo} - ${val.nome}`"
                      v-model="turma.codigo_curso"
                      label="Código do Curso"
                      dense
                      solo
                    />
                  </v-col>

                  <v-col cols="4"
                    ><v-select
                      :items="[
                        '1 - Sala Anexa',
                        '2 - Unidade de atendimento socioeducativo',
                        '3 - Unidade Prisional',
                      ]"
                      v-model="turma.local_funcionamento_diferenciado"
                      label="Local de Funcionamento Diferenciado da turma"
                      dense
                      outlined
                  /></v-col>
                </v-row>
              </v-tab-item>

              <v-tab-item>
                <v-row
                  class="mt-4"
                  v-if="
                    turma.etapa && turma.etapa !== '1' && turma.etapa !== '2' && turma.etapa !== '3'
                  "
                >
                  <v-col cols="12">
                    <label for="">Formas de Organização da turma</label>
                  </v-col>
                  <v-col v-for="campo in organizacaoTurma" :key="campo" cols="3">
                    <v-checkbox
                      :items="binarios"
                      v-model="turma[campo]"
                      :label="formatarCampo(campo)"
                      dense
                      outlined
                    />
                  </v-col>
                  <v-col cols="3">
                    <v-checkbox
                      v-model="turma.turma_formacao_alternancia"
                      :label="'Turma de Formação por alternancia'"
                      dense
                      outlined
                    />
                  </v-col>
                </v-row>
                <v-row
                  class="mt-4"
                  v-if="turma.etapa_agregada === 25 || turma.etapa_agregada === 35"
                >
                  <v-col cols="12">
                    <label for="">Organização curricular da turma</label>
                  </v-col>
                  <v-col v-for="campo in organizacaoCurricularTurma" :key="campo" cols="3">
                    <v-checkbox
                      :items="binarios"
                      v-model="turma[campo]"
                      :label="formatarCampo(campo)"
                      dense
                      outlined
                    />
                  </v-col>
                  <v-col cols="3">
                    <v-checkbox
                      v-model="turma.turma_formacao_alternancia"
                      :label="'turma_formacao_alternancia'"
                      dense
                      outlined
                    />
                  </v-col>
                </v-row>
              </v-tab-item>

              <v-tab-item>
                <v-row
                  class="mt-4"
                  v-if="turma.etapa !== '1' && turma.etapa !== '2' && turma.etapa !== '3'"
                >
                  <v-col cols="12">
                    <label for="">Áreas do Conhecimento/Componentes Curriculares</label>
                  </v-col>
                  <v-col v-for="campo in areasConhecimento" :key="campo" cols="3">
                    <label>{{ formatarCampo(campo) }}</label>
                    <v-select
                      :items="[
                        '0 - Não oferece a área do conhecimento/componente curricular.',
                        '1 - Oferece a área do conhecimento/componente curricular com docente vinculado.',
                        '2 - Oferece a área do conhecimento/componente curricular sem docente vinculado.',
                      ]"
                      v-model="turma[campo]"
                      dense
                      outlined
                    />
                  </v-col>
                  <v-col cols="12">
                    <v-checkbox
                      v-model="turma.turma_educacao_bilingue_surdos"
                      :label="'Turma de educacao bilingue de surdos'"
                      dense
                      outlined
                    />
                  </v-col>
                </v-row>
                <v-row class="mt-4" v-if="turma.itinerario_formativo">
                  <v-col cols="12">
                    <label for="">Área(s) do itinerário formativo</label>
                  </v-col>
                  <v-col v-for="campo in areasItinerario" :key="campo" cols="3">
                    <v-select
                      :items="binarios"
                      v-model="turma[campo]"
                      :label="formatarCampo(campo)"
                      dense
                      outlined
                    />
                  </v-col>
                  <v-col cols="4" v-if="turma.etapa_agregada === 25 || turma.etapa_agregada === 35">
                    <label>Itinerário de formação técnica e profissional</label>
                    <e-autocomplete
                      :items="['1 - Curso Técnico', '2 - Qualificação Profissional técnica']"
                      :return-object="false"
                      :item-value="(value) => value.codigo"
                      :item-text="(val) => `${val.codigo} - ${val.nome}`"
                      v-model="turma.tipo_curso_itinerario_formacao_tecnica_profissional"
                      label="Selecione"
                      dense
                      solo
                    />
                  </v-col>
                  <v-col
                    cols="4"
                    v-if="
                      turma.tipo_curso_itinerario_formacao_tecnica_profissional ===
                      '1 - Curso Técnico'
                    "
                  >
                    <label>Cód. Curso Técnico</label>
                    <e-autocomplete
                      :items="$constants.cursosEducacaoProfissionalList"
                      :return-object="false"
                      :item-value="(value) => value.codigo"
                      :item-text="(val) => `${val.codigo} - ${val.nome}`"
                      v-model="turma.codigo_curso_tecnico"
                      label="Código do Curso Técnico"
                      dense
                      solo
                    />
                  </v-col>
                </v-row>
              </v-tab-item>
            </v-tabs-items>
          </v-card>
        </div>
        <v-row class="mt-4">
          <v-col cols="6">
            <v-btn block color="error" @click="submitForm('prev')">
              <v-icon>mdi-chevron-left</v-icon> Etapa Anterior</v-btn
            >
          </v-col>
          <v-col cols="6">
            <v-btn block color="success" @click="submitForm('next')">
              <v-icon>mdi-chevron-right</v-icon> Próxima Etapa</v-btn
            >
          </v-col>
        </v-row>
        <v-row v-if="erros.length > 0">
          <v-col cols="12" class="mt-4" style="background-color: red; color: white">
            <v-card-title>Erros encontrados no preenchimento dos dados</v-card-title>
            <v-card-text>
              <ul v-for="(erro, index) in erros" :key="index">
                <li>{{ erro.mensagem }}</li>
              </ul>
            </v-card-text>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
  </v-container>
</template>

<script>
export default {
  data() {
    return {
      etapasAgregadas: [
        {
          codigo: 301,
          nome: "Educação Infantil",
        },
        {
          codigo: 302,
          nome: "Ensino Fundamental",
        },
        {
          codigo: 303,
          nome: "Multi e correção de fluxo",
        },
        {
          codigo: 304,
          nome: "Ensino Médio",
        },
        {
          codigo: 306,
          nome: "Educação de Jovens e Adultos",
        },
      ],
      erros: [],
      requiredRule: (v) => !!v || "Campo obrigatório",
      binarios: ["0", "1"],
      diasSemana: ["domingo", "segunda", "terca", "quarta", "quinta", "sexta", "sabado"],
      tiposTurma: ["tipo_turma_curricular", "tipo_turma_aee"],
      organizacaoTurma: [
        "serie_ano",
        "periodos_semestrais",
        "ciclos",
        "grupos_nao_seriados",
        "modulos",
      ],
      organizacaoCurricularTurma: [
        "formacao_geral_basica",
        "itinerario_formativo",
        "itinerario_formacao_tecnica_profissional",
      ],
      areasConhecimento: [
        "quimica",
        "fisica",
        "biologia",
        "ciencias",
        "lingua_portuguesa",
        "lingua_estrangeira_ingles",
        "lingua_estrangeira_espanhol",
        "lingua_estrangeira_outra",
        "arte",
        "educacao_fisica",
        "historia",
        "geografia",
        "filosofia",
        "informatica",
        "areas_conhecimento_profissionalizantes",
        "libras",
        "areas_conhecimento_pedagogicas",
        "ensino_religioso",
        "lingua_indigena",
        "estudos_sociais",
        "matematica",
        "lingua_estrangeira_frances",
        "lingua_portuguesa_segunda_lingua",
        "estagio_curricular_supervisionado",
        "projeto_vida",
        "sociologia",
        "outras_areas_conhecimento",
      ],
      areasItinerario: [
        "linguagens_tecnologias",
        "matematica_tecnologias",
        "ciencias_natureza_tecnologias",
        "ciencias_humanas_tecnologias",
      ],
      turmas: [{}],
      abas: [0],
    };
  },

  mounted() {
    this.getData();
  },

  methods: {
    validacao() {
      this.erros = [];

      this.turmas.forEach((turma, index) => {
        const tipo_de_turma = [
          "tipo_turma_curricular",
          "tipo_turma_aee",
          "tipo_turma_atividade_complementar",
        ];

        const algumMarcado = tipo_de_turma.some((campo) => turma[campo]);
        if (!algumMarcado) {
          this.erros.push({
            tipo: `tipoTurma-${index}`,
            mensagem: `Turma ${
              index + 1
            }: Pelo menos um dos campos do tipo de turma deve ser preenchido.`,
          });
        }

        // Exemplo de outro campo obrigatório (ajuste conforme necessário)
        if (!turma.descricao || turma.descricao.trim() === "") {
          this.erros.push({
            tipo: `descricao-${index}`,
            mensagem: `Turma ${index + 1}: O campo "Nome da Turma" é obrigatório.`,
          });
        }

        if (!turma.tipo_mediacao_didatico_pedagogica) {
          this.erros.push({
            tipo: `mediacao-${index}`,
            mensagem: `Turma ${index + 1}: Selecione o tipo de mediação didático-pedagógica.`,
          });
        }
        if (!turma.etapa_agregada) {
          this.erros.push({
            tipo: `etapaagregada-${index}`,
            mensagem: `Turma ${index + 1}: Selecione a Etapa Agregada.`,
          });
        }
        if (!turma.etapa) {
          this.erros.push({
            tipo: `etapa-${index}`,
            mensagem: `Turma ${index + 1}: Selecione a Etapa.`,
          });
        }

        /*
    "serie_ano",
        "periodos_semestrais",
        "ciclos",
        "grupos_nao_seriados",
        "modulos",
        */
        if (![1, 2, 3].includes(Number(turma.etapa))) {
          const organizacaoTurma = [
            "serie_ano",
            "periodos_semestrais",
            "ciclos",
            "grupos_nao_seriados",
            "modulos",
          ];

          const algumMarcadoTurma = organizacaoTurma.some((campo) => turma[campo]);
          if (!algumMarcadoTurma) {
            this.erros.push({
              tipo: `organizacaoTurma-${index}`,
              mensagem: `Turma ${
                index + 1
              }: Pelo menos um dos campos da organização da turma deve ser preenchido.`,
            });
          }
        }
        const horarioTurma = [
          "horario_domingo_inicio",
          "horario_domingo_fim",
          "horario_segunda_inicio",
          "horario_segunda_fim",
          "horario_terca_inicio",
          "horario_terca_fim",
          "horario_quarta_inicio",
          "horario_quarta_fim",
          "horario_quinta_inicio",
          "horario_quinta_fim",
          "horario_sexta_inicio",
          "horario_sexta_fim",
          "horario_sabado_inicio",
          "horario_sabado_fim",
        ];

        const algumMarcadoHorario = horarioTurma.some((campo) => turma[campo]);
        if (!algumMarcadoHorario) {
          this.erros.push({
            tipo: `horarioTurma-${index}`,
            mensagem: `Turma ${
              index + 1
            }: Pelo menos um dos campos de horário da turma deve ser preenchido.`,
          });
        }

        /*
       "quimica",
        "fisica",
        "biologia",
        "ciencias",
        "lingua_portuguesa",
        "lingua_estrangeira_ingles",
        "lingua_estrangeira_espanhol",
        "lingua_estrangeira_outra",
        "arte",
        "educacao_fisica",
        "historia",
        "geografia",
        "filosofia",
        "informatica",
        "areas_conhecimento_profissionalizantes",
        "libras",
        "areas_conhecimento_pedagogicas",
        "ensino_religioso",
        "lingua_indigena",
        "estudos_sociais",
        "matematica",
        "lingua_estrangeira_frances",
        "lingua_portuguesa_segunda_lingua",
        "estagio_curricular_supervisionado",
        "projeto_vida",
        "sociologia",
    */
        // se o campo etapa da turma for diferente de 1 ,2 e 3
        if (![1, 2, 3].includes(Number(turma.etapa))) {
          const organizacaoDisciplina = [
            "quimica",
            "fisica",
            "biologia",
            "ciencias",
            "lingua_portuguesa",
            "lingua_estrangeira_ingles",
            "lingua_estrangeira_espanhol",
            "lingua_estrangeira_outra",
            "arte",
            "educacao_fisica",
            "historia",
            "geografia",
            "filosofia",
            "informatica",
            "areas_conhecimento_profissionalizantes",
            "libras",
            "areas_conhecimento_pedagogicas",
            "ensino_religioso",
            "lingua_indigena",
            "estudos_sociais",
            "matematica",
            "lingua_estrangeira_frances",
            "lingua_portuguesa_segunda_lingua",
            "estagio_curricular_supervisionado",
            "projeto_vida",
            "sociologia",
          ];

          const algumMarcadoDisciplina = organizacaoDisciplina.some((campo) => turma[campo]);

          if (!algumMarcadoDisciplina) {
            this.erros.push({
              tipo: `organizacaoDisciplina-${index}`,
              mensagem: `Turma ${
                index + 1
              }: Pelo menos um dos campos de Áreas do Conhecimento da turma deve ser preenchido.`,
            });
          }
        }

        // Continue adicionando outras validações necessárias para sua estrutura
      });
    },
    adicionarLinha() {
      this.turmas.push({});
      this.abas.push(0);
    },
    removerLinha(index) {
      this.turmas.splice(index, 1);
      this.abas.splice(index, 1);
    },
    salvar() {},
    formatarCampo(campo) {
      return campo.replace(/_/g, " ").replace(/\b\w/g, (l) => l.toUpperCase());
    },

    async getData() {
      this.$loaderService.open("Carregando...");
      const data = await this.$services.censoService.getData("aba20");

      data.forEach((turma) => {
        this.diasSemana.forEach((dia) => {
          const campo = `horario_${dia}`; // ex: "horario_segunda"
          if (turma[campo] && turma[campo].includes("-")) {
            const [inicio, fim] = turma[campo].split("-");
            turma[`horario_${dia}_inicio`] = inicio;
            turma[`horario_${dia}_fim`] = fim;
          }
        });
      });

      this.turmas = data;
      this.$loaderService.close();
    },

    async submitForm(type) {
      if (type === "next") {
        this.validacao();
      }
      if (!this.erros.length > 0) {
        try {
          await this.$services.censoService.saveData(this.turmas, "aba20");

          if (type === "next") {
            this.$emit("event", "tab-4");
          } else {
            this.$emit("event", "tab-2");
          }
        } catch (error) {
          this.$handleError(error);
        }
      }
    },
  },
};
</script>

<style scoped>
.v-card {
  border: 1px solid #ccc;
}
</style>
